<template>
    <Card>
        <div v-if="!isSupplier" class="card-body">
            <router-link
                class="btn btn-link"
                :to="{name: 'CreateCategoryPage'}"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ $t("buttons.create") }}
            </router-link>
        </div>
        <FetchTable
            :url="`/projects/${$route.params.projectUuid}/pim/channels/${integration.uuid}/categories`"
            :handle="tableHandle"
            :columns="columns"
            v-model:orders="orders"
            :has-checkbox="!isSupplier"
            @update:selectedValues="selectedCategories = $event"
        >
            <template v-if="!isSupplier" #actionDropdownItems>
                <DropdownItem @click="$refs.DeleteCategoriesModal.show(selectedCategories)">{{ $t('buttons.delete') }}</DropdownItem>
            </template>
            <template #td-id="{row}">
                <AppNullableCell>
                    <template #default v-if="row.id">
                        <span class="long-string" :title="row.id">
                            <router-link :to="{name: 'EditCategoryCard', params: {categoryUuid: row.uuid}}">
                                {{ row.id }}
                            </router-link>
                        </span>
                    </template>
                </AppNullableCell>
            </template>
            <template #td-source_id="{row}">
                <AppNullableCell>
                    <template #default v-if="row.source_id">
                        {{ row.source_id }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-second_source_id="{row}">
                <AppNullableCell>
                    <template #default v-if="row.second_source_id">
                        {{ row.second_source_id }}
                    </template>
                </AppNullableCell>
            </template>
            <template #[`td-name_${lang}`]="{row}" v-for="lang in integration.language_aliases" :key="`name_${lang}`">
                <AppNullableCell>
                    <template #default v-if="row.names[lang]">
                        <span class="long-string" :title="row.names[lang]">{{ row.names[lang] }}</span>
                    </template>
                </AppNullableCell>
            </template>
            <template #td-integration_product_items_count="{row}">
                {{ row.integration_product_items_count }}
            </template>
        </FetchTable>
    </Card>
    <DeleteCategoriesModal ref="DeleteCategoriesModal" @categories:deleted="tableHandle.fetchRows({extra_fields: ['productsCount']})"/>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";
import AppNullableCell from "../../../components/tables/AppNullableCell.vue";
import DeleteCategoriesModal from "../modals/DeleteCategoriesModal.vue";
import DropdownItem from "../../../components/btnDropdown/DropdownItem.vue";
import { IntegrationServiceEnum } from "../../../enums/IntegrationServiceEnum";

export default {
    name: "CategoriesCard",
    components: {
        Card, FetchTable, AppNullableCell, DeleteCategoriesModal, DropdownItem
    },
    props: {
        integration: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            columns: [],
            orders: [],
            selectedCategories: []
        }
    },
    created() {
        let languages = this.integration.language_aliases;

        let langFields = languages.map(lang => ({
            key: `name_${lang}`,
            name: this.$t(`table.titles.name`) + ` (${this.$t(`shortLang.${lang}`)})`,
            width: 'auto',
            type: 'string',
            order: true,
            orderColumn: `names->${lang}`
        }));

        this.columns = [
            {key: "id", name: this.$t('table.titles.id'), width: "auto", type: "string", order: true},
            {key: "source_id", name: this.$t('table.titles.source_id'), width: "auto", type: "string", order: true},
            {key: "second_source_id", name: this.$t('table.titles.second_source_id'), width: "auto", type: "string", order: true},
            ...langFields,
            {key: 'integration_product_items_count', name: this.$t('table.titles.publications'), width: 'auto', type: 'string', order: true}
        ];
    },
    computed: {
        isSupplier() {
            return this.integration.service === IntegrationServiceEnum.SUPPLIER
        },
        mainIntegrationLanguages() {
            return this.integration.language_aliases[0];
        }
    },
    mounted() {
        this.tableHandle.fetchRows({extra_fields: ['productsCount']});
    }
}
</script>
<style scoped>
.long-string {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
